import { useQuery } from '@tanstack/react-query'
import { isDemoSession } from '@/auth/oidc'
import { keys } from '@/api/hooks/shared/keys'
import {
  demoSearchHierarchyPage,
  hierarchySearchLive,
  searchHierarchyPage,
} from '@/api/map/hierarchySearch'

export function useSearchHierarchyPage(
  filter: string[],
  opts: { page?: number; serchById?: boolean; enabled?: boolean } = {},
) {
  const page = opts.page ?? 1
  const serchById = opts.serchById ?? false
  const enabled = (opts.enabled ?? true) && filter.length > 0

  return useQuery({
    queryKey: keys.searchHierarchyPage({ filter, page, serchById }),
    enabled,
    queryFn: async () => {
      if (!hierarchySearchLive() || isDemoSession()) {
        return demoSearchHierarchyPage(filter)
      }
      return searchHierarchyPage({ filter, page, serchById })
    },
  })
}
